// extracted by mini-css-extract-plugin
export default {"errorList":"v0bTWpPbE5aRTkwdvMkA","centerDot":"gQb1rSzKk8XRLXeeuz40"};